export enum StorageType {
  Local = 'localStorage',
  Session = 'sessionStorage',
}

export class StorageBaseService {
  protected static type: StorageType;

  static has(key: string): boolean {
    return !!this.get(key);
  }

  static set(key: string, data: unknown): void {
    return this.storage.setItem(key, JSON.stringify(data));
  }

  static get<T = unknown>(key: string): T | null {
    const item: string | null = this.storage.getItem(key);

    return item ? JSON.parse(item) : item;
  }

  static delete(key: string): void {
    return this.storage.removeItem(key);
  }

  private static get storage(): Storage {
    return window[this.type];
  }
}
